// extracted by mini-css-extract-plugin
module.exports = {"WithMachinesAndMaterials":"WithMachinesAndMaterials_WithMachinesAndMaterials__3GPAq","header":"WithMachinesAndMaterials_header__KyReW"};